const FinBankCreditScoreInfoI18n = {
  scoreInfo: {
    sections: {
      personalData: 'Individual registration data',
      companyData: 'Company registration data',
      contact: 'Contact',
      address: 'Address',
    },
    personalData: {
      cpf: 'CPF',
      nome: 'Name',
      nomeMae: "Mother's name",
      dataNascimento: 'Date of birth',
      nacionalidade: 'Nationality',
      obito: 'Deceased',
      escolaridade: 'Education',
    },
    companyData: {
      cnpj: 'CNPJ',
      razaoSocial: 'Legal name',
      nomeFantasia: 'Trade name',
      natureza: 'Legal nature',
      porte: 'CNPJ Status',
      atividadePrincipal: 'Main activity',
      dataAbertura: 'Opening date',
      capitalSocial: 'Current share capital',
      dataCapitalSocial: 'Last share capital change date',
    },
    contact: {
      telefonePrincipal: 'Primary phone',
      telefoneSecundario: 'Secondary phone',
    },
    address: {
      itemLabel: 'Address {{index}}',
      pageIndicator: '{{current}} of {{total}}',
      rua: 'Street',
      bairro: 'Neighborhood',
      cidade: 'City',
      complemento: 'Complement',
      estado: 'State',
      cep: 'ZIP code',
      empty: 'No address registered',
    },
    consumerStatus: {
      title: 'Consumer status',
      subtitleActive: 'Positive record',
      subtitleInactive: 'Negative record',
      active: 'Active',
      inactive: 'Inactive',
    },
    values: {
      yes: 'Yes',
      no: 'No',
      notInformed: 'Not informed',
    },
  },
};

export default FinBankCreditScoreInfoI18n;
